import React from 'react'
import clsx from 'clsx'
import ContactDetailsBlock from '@Components/ViewWork/PublisherCard/ContactDetailsBlock'
import { Maybe } from '@Types'
import { RightsholderContact } from '@Entities/rightsholder/rightsholder-contact'

interface PublisherContactSectionProps {
    displayContact: boolean
    publicContactHeader: boolean
    isSubPublisher?: boolean
    publicContact?: Maybe<RightsholderContact>
}

const PublisherContactSection = ({
    displayContact,
    publicContactHeader,
    isSubPublisher,
    publicContact,
}: PublisherContactSectionProps) => (
    <>
        {displayContact && (
            <div
                className={clsx('contact-information', !publicContactHeader && 'hide-header')}
                data-label="Contact Details"
            >
                {!isSubPublisher && publicContact ? (
                    <ContactDetailsBlock contact={publicContact} />
                ) : (
                    !isSubPublisher && 'No Contact Details'
                )}
            </div>
        )}
    </>
)

export default PublisherContactSection
